import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import LargeItemStatus from "../../../../../../common/components/large_item_status";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import PrimaryButton from "../../../../../../common/components/primary_button";

type Props = {
  onActionEditar: (idDisciplina: number | null, openState: boolean) => void;
  onActionDeletar: (idDisciplina: number | null, openState: boolean) => void;
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void,

  onDownloadFile?: (filename: string, ordem: number, idDisciplinaArquivo: number) => void;
};

export const GenerateProjetoDisciplinasArquivosColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
  onOpenChangeHistory,
  onDownloadFile,
}: Props): GridColDef[] => {

  const computeStatusColor = (status: string): "red" | "blue" | "yellow" | "green" | "gray" => {
    switch (status) {
      case "EA":
        return "yellow"; // Em andamento
      case "AT":
        return "red"; // Atrasada
      case "CD":
        return "green"; // Concluído no prazo
      case "CA":
        return "blue"; // Concluído com atraso
      case "NI":
        return "gray"; // Não iniciado
      case "NA":
        return "gray"; // Data não informada
      default:
        return "gray";
    }
  };

  const computeStatusDescription = (status: string) => {
    switch (status) {
      case "EA":
        return "Em Andamento";
      case "AT":
        return "Atrasada";
      case "CD":
        return "Concluído Dentro do Prazo";
      case "CA":
        return "Concluído Com Atraso";
      case "NI":
        return "Não Foi Iniciado";
      case "NA":
        return "Data Não Informada";
      default:
        return "?";
    }
  };

  const computeAnaliseDescription = (analise: string) => {
    switch (analise) {
      case "EA":
        return "Em Andamento";
      case "E":
        return "Encerrada";
      default:
        return "?";
    }
  };

  const computeAnaliseColor = (analise: string): "red" | "blue" | "yellow" | "green" | "gray" => {
    switch (analise) {
      case "EA": // Análise em andamento
        return "yellow";
      case "E": // Análise encerrada
        return "red";
      default:
        return "gray";
    }
  };

  return [
    {
      field: "disciplina",
      headerName: "Disciplina",
      minWidth: 120,
      flex: 1,
      sortable: false,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={params.value}
            color={computeStatusColor(params.value)}
            description={computeStatusDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "analise",
      headerName: "Análise",
      minWidth: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={params.value}
            color={computeAnaliseColor(params.value)}
            description={computeAnaliseDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "prancha",
      headerName: "Prancha",
      minWidth: 120,
      sortable: false,
    },
    {
      field: "revisao",
      headerName: "Revisão",
      minWidth: 100,
      sortable: false,
    },
    {
      field: "nome",
      filterable: false,
      headerName: "Arquivo-1",
      minWidth: 175,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        arquivoNome: rows["nome"],
        idDisciplinaArquivo: rows["idDisciplina"],
      }),
      renderCell: (params) => {
        const maxSize = 20;
        const arquivoNome = params.value["arquivoNome"] as string;
        const idDisciplinaArquivo = params.value["idDisciplinaArquivo"] as number;

        return (
          <Button
            onMouseDown={() => onDownloadFile && onDownloadFile(arquivoNome, 1, idDisciplinaArquivo )}
            sx={{
              fontSize: 11,
              paddingX: ".4rem",
              paddingY: 0,
              background: "#e6e6e6",
              borderLeft: ".3rem solid #45b6af",
              borderRadius: 0,
              color: "black",
              fontWeight: "normal",
              width: "9.5rem",
            }}
          >
            {arquivoNome && arquivoNome.length > maxSize ? `${arquivoNome.substring(0, maxSize)}...` : arquivoNome}
          </Button>
        );
      },
    },
    {
      field: "nome2",
      filterable: false,
      headerName: "Arquivo-2",
      minWidth: 175,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        arquivoNome2: rows["nome2"],
        idDisciplinaArquivo: rows["idDisciplina"],
      }),
      renderCell: (params) => {
        const maxSize = 20;
        const arquivoNome2 = params.value["arquivoNome2"] as string;
        const idDisciplinaArquivo = params.value["idDisciplinaArquivo"] as number;

        return (
          <Button
            onMouseDown={() => onDownloadFile && onDownloadFile(arquivoNome2, 2, idDisciplinaArquivo  )}
            sx={{
              fontSize: 11,
              paddingX: ".4rem",
              paddingY: 0,
              background: "#e6e6e6",
              borderLeft: ".3rem solid #45b6af",
              borderRadius: 0,
              color: "black",
              fontWeight: "normal",
              width: "9.5rem",
            }}
          >
            {arquivoNome2 && arquivoNome2.length > maxSize ? `${arquivoNome2.substring(0, maxSize)}...` : arquivoNome2}
          </Button>
        );
      },
    },
    {
      field: "tamanho",
      headerName: "Espaço Utilizado (Mb)",
      minWidth: 120,
      sortable: false,
      renderCell: (params) => {
        return (<span className="w-full h-full flex justify-center items-center text-center text-sm py-2">{params.value && params.value.toFixed(3)}</span>);
      },
    },
    {
      field: "idDisciplina",
      headerName: "Ações",
      width: 100,
      sortable: false,
      valueGetter: (_, rows) => ({
        nome: rows["nome"],
        nome2: rows["nome2"],
      }),
      renderCell: (params) => {
        const temArquivo = !!params.value["nome"];
        const temArquivo2 = !!params.value["nome2"];

        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.row.idDisciplina, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="text-primary-green" />
            </IconButton>
            {
              (temArquivo || temArquivo2) &&
              <IconButton onClick={() => onActionDeletar(params.row.idDisciplina, true)}>
                <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
              </IconButton>
            }

          </div>
        )
      }
    },
    {
      field: "idDisciplinaArquivo",
      headerName: "Histórico",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          params.value ? (
            < div className="flex items-center justify-center w-full h-full gap-2" >
              <PrimaryButton
                buttonColor="yellow"
                onClick={() => onOpenChangeHistory(params.value, LogTipoTabela.DISCIPLINA_ARQUIVO)}>
                <span className="text-xs">
                  Histórico
                </span>
              </PrimaryButton>
            </div >) : (<> </>)
        )
      }
    },
  ];
};
